/**
 * List of X-Auth-Ids for Admins
 */
export const adminXAuthIds = [
  'da4fb5c6e93e74d3df8527599fa62642',
  'bb921944c8c4531826da3fa99b494c1a',
  '8f14e45fceea167a5a36dedd4bea2543'
]

export const QNAXAuthIds = [
  '47f64e755012d2865986a027f473d3c3',
  '6664bc263946ddf171c80925597ec365',
  '17b23891e3be5e4b6cd3c67e2f6e14ef',
  '0fb164710abaabbf4863eb3ec59f7ab7',
  '1057d6de7b6d0d12d42efddaec322a4a',
  'f0783b16485abed7aa81a54153c913b7',
  '3516ebe780ced5b002538322907e5c2d',
  '1ee2e5e34c2886bf91b82adfcea38b4c',
  '3d72200b4ba705d927bdc2a4c4248732',
  'bb921944c8c4531826da3fa99b494c1a',
  'b3f04366b72a09913c432b0c2a1266d9',
  'f1e1fd9e97f59379ed79bdf258d55042'
]

export const BASE_API_URL = 'https://teenpatti.money91.com'
// export const BASE_API_URL = 'https://teenpatti.money91.com'
export const SOCKET_URL = 'wss://teenpatti.money91.com'
export const LOCAL_URL = 'https://dev4.money91.com'
export const SOCKET_LOCAL_URL = 'wss://dev4.money91.com'
